<template>
    <form @submit.prevent="save">
        <div class="modal_content m-b-0">
            <div class="row">
                <div class="col-sm-3 col-md-2">
                    <div class="t_center">
                        <img src="/static/images/avatar-company.png" alt="" class="img-responsive img-circle m_15_auto_0 max_120">
                    </div>
                </div>
                <div class="col-sm-9 col-md-10">
                    <div class="row">
                        <div class="col-sm-6 m_bottom_15" :class="{'has-error': errors['name']}">
                            <label>{{ $t('name') }}</label>
                            <input type="text" class="form-control" v-model="record.name" v-pml-focus ref="mainInput">
                            <span class="error" v-if="errors['name']">{{ errors['name'][0] }}</span>
                        </div>
                        <div class="col-sm-6 m_bottom_15" :class="{'has-error': errors['fancy_name']}">
                            <label>{{ $t('fancy_name') }}</label>
                            <input type="text" class="form-control" v-model="record.fancy_name">
                            <span class="error" v-if="errors['fancy_name']">{{ errors['fancy_name'][0] }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-md-4">
                            <label class="input-group m_bottom_15" :class="{'has-error': errors['phone']}">
                                <span class="input-group-addon" v-pml-tooltip="$t('phone')"><i class="fa-fw fa fa-phone"></i></span>
                                <input type="text" class="form-control" :placeholder="$t('phone')" v-model="record.phone">
                                <span class="error" v-if="errors['phone']">{{ errors['phone'][0] }}</span>
                            </label>
                        </div>
                        <div class="col-sm-6 col-md-4">
                            <label class="input-group m_bottom_15" :class="{'has-error': errors['email']}">
                                <span class="input-group-addon" v-pml-tooltip="$t('email')"><i class="fa-fw fa fa-envelope"></i></span>
                                <input type="text" class="form-control" :placeholder="$t('email')" v-model="record.email">
                                <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
                            </label>
                        </div>
                        <div class="col-sm-6 col-md-4">
                            <label class="input-group m_bottom_15" :class="{'has-error': errors['website']}">
                                <span class="input-group-addon" v-pml-tooltip="$t('website')"><i class="fa-fw fa fa-desktop"></i></span>
                                <input type="text" class="form-control" :placeholder="$t('website')" v-model="record.website">
                                <span class="error" v-if="errors['website']">{{ errors['website'][0] }}</span>
                            </label>
                        </div>
                        <div class="col-sm-6 col-md-4">
                            <label class="input-group m_bottom_15" :class="{'has-error': errors['facebook']}">
                                <span class="input-group-addon" v-pml-tooltip="'Facebook'" :translate="false"><i class="fa-fw fa fa-facebook"></i></span>
                                <input type="text" class="form-control" placeholder="Facebook" v-model="record.facebook">
                                <span class="error" v-if="errors['facebook']">{{ errors['facebook'][0] }}</span>
                            </label>
                        </div>
                        <div class="col-sm-6 col-md-4">
                            <label class="input-group m_bottom_15" :class="{'has-error': errors['linkedin']}">
                                <span class="input-group-addon" v-pml-tooltip="'LinkedIn'" :translate="false"><i class="fa-fw fa fa-linkedin"></i></span>
                                <input type="text" class="form-control" placeholder="LinkedIn" v-model="record.linkedin">
                                <span class="error" v-if="errors['linkedin']">{{ errors['linkedin'][0] }}</span>
                            </label>
                        </div>
                        <div class="col-sm-6 col-md-4" :class="{'has-error': errors['currency_id']}">
                            <label class="input-group m_bottom_15">
                                <span class="input-group-addon" v-pml-tooltip="$t('currency')"><i class="fa-fw fa fa-dollar"></i></span>
                                <pml-select-currencies v-model="record.currency_id" :value="record.currency_id"></pml-select-currencies>
                            </label>
                            <span class="error" v-if="errors['currency_id']">{{ errors['currency_id'][0] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal_content m-b-0">
            <h5 class="m-t-0"><i class="fa fa-home"></i> {{ $t('address') }}</h5>
            <div class="row">
                <div class="col-sm-8 col-md-9 m_bottom_15" :class="{'has-error': errors['address']}">
                    <label>{{ $t('address') }}</label>
                    <input type="text" class="form-control" v-model="record.address">
                    <span class="error" v-if="errors['address']">{{ errors['address'][0] }}</span>
                </div>
                <div class="col-sm-4 col-md-3 m_bottom_15" :class="{'has-error': errors['zip_code']}">
                    <label>{{ $t('zip_code') }}</label>
                    <input type="text" class="form-control" v-model="record.zip_code">
                    <span class="error" v-if="errors['zip_code']">{{ errors['zip_code'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8 col-md-9 m_bottom_15" :class="{'has-error': errors['complement']}">
                    <label>{{ $t('complement') }}</label>
                    <input type="text" class="form-control" v-model="record.complement">
                    <span class="error" v-if="errors['complement']">{{ errors['complement'][0] }}</span>
                </div>
                <div class="col-sm-4 col-md-3 m_bottom_15" :class="{'has-error': errors['country_id']}">
                    <label>{{ $t('country') }}</label>
                    <pml-select-countries v-model="record.country_id" :value="record.country_id"></pml-select-countries>
                    <span class="error" v-if="errors['country_id']">{{ errors['country_id'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 m_bottom_15" :class="{'has-error': errors['state']}">
                    <label>{{ $t('state') }}</label>
                    <input type="text" class="form-control" v-model="record.state">
                    <span class="error" v-if="errors['state']">{{ errors['state'][0] }}</span>
                </div>
                <div class="col-sm-4 m_bottom_15" :class="{'has-error': errors['city']}">
                    <label>{{ $t('city') }}</label>
                    <input type="text" class="form-control" v-model="record.city">
                    <span class="error" v-if="errors['city']">{{ errors['city'][0] }}</span>
                </div>
                <div class="col-sm-4 m_bottom_15" :class="{'has-error': errors['district']}">
                    <label>{{ $t('district') }}</label>
                    <input type="text" class="form-control" v-model="record.district">
                    <span class="error" v-if="errors['district']">{{ errors['district'][0] }}</span>
                </div>
            </div>
        </div>
        <div class="modal_content">
            <div class="row">
                <div class="col-xs-12 m_bottom_15" :class="{'has-error': errors['about']}">
                    <h5 class="m-t-0"><i class="fa fa-info-circle"></i> {{ $t('about') }}</h5>
                    <textarea type="text" class="form-control" rows="3" v-model="record.about" v-pml-autosize :placeholder="$t('description_in_quotation')"></textarea>
                    <span class="error" v-if="errors['about']">{{ errors['about'][0] }}</span>
                </div>
            </div>
        </div>
        <div class="modal_content">
            <h5 class="m-t-0"><i class="fa fa-user"></i> {{ $t('contact') }}</h5>
            <div class="row">
                <div class="col-sm-6 m-b-20" :class="{'has-error': errors['contact_name']}">
                    <input type="text" class="form-control" v-model="record.contact_name" :placeholder="$t('name')">
                    <span class="error" v-if="errors['contact_name']">{{ errors['contact_name'][0] }}</span>
                </div>
                <div class="col-sm-6">
                    <label class="input-group m_bottom_15" :class="{'has-error': errors['contact_email']}">
                        <span class="input-group-addon" v-pml-tooltip="$t('email')"><i class="fa-fw fa fa-envelope"></i></span>
                        <input type="email" class="form-control" :placeholder="$t('email')" v-model="record.contact_email">
                        <span class="error" v-if="errors['contact_email']">{{ errors['contact_email'][0] }}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="input-group m_bottom_15" :class="{'has-error': errors['contact_phone']}">
                        <span class="input-group-addon" v-pml-tooltip="$t('phone')"><i class="fa-fw fa fa-phone"></i></span>
                        <input type="text" class="form-control" :placeholder="$t('phone')" v-model="record.contact_phone">
                        <span class="error" v-if="errors['contact_phone']">{{ errors['contact_phone'][0] }}</span>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="input-group m_bottom_15" :class="{'has-error': errors['contact_mobile']}">
                        <span class="input-group-addon" v-pml-tooltip="$t('mobile')"><i class="fa-fw fa fa-mobile"></i></span>
                        <input type="text" class="form-control" :placeholder="$t('mobile')" v-model="record.contact_mobile">
                        <span class="error" v-if="errors['contact_mobile']">{{ errors['contact_mobile'][0] }}</span>
                    </label>
                </div>
            </div>
            <div class="clearfix">
                <router-link :to="{ name: 'suppliers.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { create, update } from 'services/suppliers'
    import { mapGetters } from 'vuex'
    import { find, isNil, cloneDeep } from 'lodash'

    export default {
        name: 'SuppliersForm',
        data () {
            return {
                record: {
                    currency_id: '',
                    country_id: '',
                    active: 1
                },
                errors: [],
                isSaving: false
            }
        },
        mounted () {
            this.init()
        },
        watch: {
            '$route' () {
                this.init()
            }
        },
        computed: {
            ...mapGetters({
                'suppliers': 'getSuppliers'
            })
        },
        methods: {
            init () {
                typeof this.$route.params.id !== 'undefined' ? this.fetchRecord(this.$route.params.id) : this.clear()
            },
            fetchRecord (id) {
                this.record = cloneDeep(find(this.suppliers, { id: parseInt(id) }))
            },
            save () {
                this.isSaving = true

                this.request()
                    .then(() => {
                        Notify.success(trans('the_record_has_been_saved'))
                        this.$router.push({ name: 'suppliers.index' })
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            request () {
                return isNil(this.record.id) ? create(this.record) : update(this.$route.params.id, this.record)
            },
            clear () {
                this.record = {
                    currency_id: '',
                    country_id: '',
                    active: 1
                }
                this.errors = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/suppliers/components/Form.vue